import React from 'react'

// material ui
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

// shared components
import Loading from 'components/atoms/Loading'
import ErrorMessage from 'components/shared/ErrorMessage'
import RoomMeetingCard from 'components/virtual/shared/RoomMeetingCard'

// local components
import Filters from './Filters'

const Schedule = props => {
  const { loading, roomMeetings } = props

  return (
    <Container maxWidth='lg'>
      <Box mt={2}>
        <ErrorMessage />
      </Box>
      <Filters {...props} />
      <Box pt={4}>
        {loading ? (
          <Loading />
        ) : (
          <>
            {roomMeetings.length === 0 ? (
              <Typography align='center'>No activities today.</Typography>
            ) : (
              <Grid container spacing={4}>
                {roomMeetings.map(roomMeeting => (
                  <RoomMeetingCard
                    key={roomMeeting.id}
                    actions={false}
                    roomMeeting={roomMeeting}
                  />
                ))}
              </Grid>
            )}
          </>
        )}
      </Box>
    </Container>
  )
}

export default Schedule
